import React from 'react';
import { Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';


const Footer = props => {

    // const classes = useStyles()

    return (
        <div style={{ marginTop: 20, padding: 16 }}>
            <Grid container justifyContent="space-between" alignItems="center" direction="row">
                <Grid style={{ display: "flex", gap: 8 }}>
                    <a target='_blank' rel="noopener noreferrer" href='https://www.instagram.com/coopganansol/'><img src={process.env.PUBLIC_URL + '/images/instagram.svg'} alt="Logo" /></a>
                    <a target='_blank' rel="noopener noreferrer" href='https://www.facebook.com/coacganansol/'><img src={process.env.PUBLIC_URL + '/images/facebook.svg'} alt="Logo" /></a>
                    {/* <a href='#'><img src={process.env.PUBLIC_URL + '/images/tiktok.svg'} alt="Logo" /></a> */}
                
                
                

                </Grid>
                <img src={process.env.PUBLIC_URL + '/images/sello.svg'} alt="Logo" style={{ width: isMobile ? 160 : "unset" }} />
            </Grid>
        </div>
    );

}

export default Footer;